import React, { useMemo, useEffect } from "react";
import { TaglineM } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import CardRightV2 from "../cardRightV2";
import CommentExample from "../CommentSection/CommentSection";
import InputV3 from "../input/novo/input_v3";
import SelectV2Multi from "../select/select_v2_multi";
import ButtonAddNew from "../buttonAddNew";

const defaultStatusOptions = [
  { value: 1, label: "Não iniciado" },
  { value: 2, label: "Em progresso" },
  { value: 3, label: "Aguardando aprovação" },
  { value: 4, label: "Pausado" },
  { value: 5, label: "Atrasado" },
  { value: 6, label: "Cancelado" },
  { value: 7, label: "Feito" },
];

const formatCPF = (value) => {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  return value;
};

const formatCNPJ = (value) => {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{2})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1/$2");
  value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  return value;
};

const formatCPFOrCNPJ = (value) => {
  if (!value) return "";
  const cleaned = value.replace(/\D/g, "");
  return cleaned.length <= 11 ? formatCPF(value) : formatCNPJ(value);
};

const ModalCreateOrEditEvent = ({
  open,
  onOpenChange,
  isEdit,
  onDelete,
  updateDelete,
  styles,
  responsavelTecnicoValue,
  onResponsavelTecnicoChange,
  agronomists = [],
  agronomistError,
  onAddAgronomist,
  produtorValue,
  onProdutorChange,
  producers = [],
  producerError,
  onAddProducer,
  fazendaValue,
  onFazendaChange,
  agroFarms = [],
  farmError,
  isFarmDisabled = false,
  isButtonFarmDisabled = false,
  onAddFarm,
  titleValue,
  onTitleChange,
  titleError,
  descriptionValue,
  onDescriptionChange,
  descriptionError,
  culturaValue,
  onCulturaChange,
  cultures = [],
  cultureError,
  startDateValue,
  onStartDateChange,
  startDateError,
  endDateValue,
  onEndDateChange,
  endDateError,
  statusRef,
  statusValue,
  onStatusChange,
  statusError,
  statusFloatingValue,
  statusOptions = defaultStatusOptions,
  mapCoords,
  buildMapUrl,
  showComment = true,
  commentResourceId = 0,
  onSave,
  isLoading,
}) => {
  const hasMap = mapCoords?.latitude && mapCoords?.longitude && buildMapUrl;

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("modal-calendar-toggle", { detail: { open } }));
  }, [open]);

  const producerOptions = useMemo(
    () =>
      producers.map((producer) => {
        const producerCpfCnpj = producer.cpf_cnpj || producer.cpfCnpj || "";
        const formattedDocument = formatCPFOrCNPJ(producerCpfCnpj);
        const baseLabel = producer.nome || producer.nome_produtor || producer.label || "";
        const label =
          formattedDocument && !baseLabel.includes(formattedDocument)
            ? `${baseLabel} - ${formattedDocument}`
            : baseLabel;

        return {
          ...producer,
          label,
        };
      }),
    [producers]
  );

  return (
      <CardRightV2
        open={open}
        updateIsOpen={onOpenChange}
        animation={false}
        title={isEdit ? "Editar evento" : "Criar evento"}
        isEdit={isEdit}
        updateDelete={onDelete || updateDelete}
      >
        <styles.ContainerNewCardRight>
          <styles.WrapperNewCardRight>
            <InputV3
              type="text"
              floatingLabelWithAsterisk="Título do evento"
              value={titleValue}
              onChange={onTitleChange}
              hasError={titleError}
            />

            <styles.TextArea
              placeholder="Descrição do evento"
              value={descriptionValue}
              onChange={onDescriptionChange}
              hasError={descriptionError}
            />

            <styles.InputAndButton>
              <div style={{ width: "100%", height: "50px" }}>
                <SelectV2Multi
                  height="auto"
                  marginBottom="24px"
                  name="responsavelTecnico"
                  className="select"
                  label="Responsável Técnico"
                  labelWithAsterisk={true}
                  id="responsavelTecnico"
                  value={responsavelTecnicoValue}
                  disabled={false}
                  loading={false}
                  erro={agronomistError}
                  onChange={onResponsavelTecnicoChange}
                  options={agronomists}
                  selectUniqueOption={true}
                  buttonAddNew={false}
                  messageErro=""
                  isModal={true}
                  isClearable={true}
                  resetOnBlur={true}
                  labelColor="#8A92A2"
                  labelMarginLeft="14px"
                  inputColor="#21262F"
                  InputFontSize="14px"
                  InputFontWeight="400"
                  InputPadding="13px 65px 12px 14px"
                  colorBorder="solid 1px #8A92A2"
                />
              </div>

              <ButtonAddNew onClick={onAddAgronomist} />
            </styles.InputAndButton>

            <styles.InputAndButton>
              <div style={{ width: "100%", height: "50px" }}>
                <SelectV2Multi
                  height="auto"
                  marginBottom="24px"
                  name="Produtor"
                  className="select"
                  label="Produtor"
                  labelWithAsterisk={false}
                  id="produtor"
                  value={produtorValue}
                  disabled={false}
                  loading={false}
                  erro={producerError}
                  onChange={onProdutorChange}
                  options={producerOptions}
                  selectUniqueOption={true}
                  buttonAddNew={false}
                  messageErro={producerError ? "Selecione um produtor" : ""}
                  isModal={true}
                  isClearable={true}
                  labelColor="#8A92A2"
                  labelMarginLeft="14px"
                  inputColor="#21262F"
                  InputFontSize="14px"
                  InputFontWeight="400"
                  InputPadding="13px 65px 12px 14px"
                  colorBorder="solid 1px #8A92A2"
                />
              </div>

              <ButtonAddNew onClick={onAddProducer} />
            </styles.InputAndButton>

            <styles.InputAndButton>
              <div style={{ width: "100%", height: "50px" }}>
                <SelectV2Multi
                  height="auto"
                  marginBottom="24px"
                  name="Fazenda/Sítio"
                  className="select"
                  label="Fazenda/Sítio"
                  labelWithAsterisk={false}
                  id="Fazenda/Sítio"
                  value={fazendaValue}
                  disabled={isFarmDisabled}
                  loading={false}
                  erro={farmError}
                  onChange={onFazendaChange}
                  options={agroFarms}
                  selectUniqueOption={true}
                  buttonAddNew={false}
                  messageErro=""
                  isModal={true}
                  isClearable={true}
                  labelColor="#8A92A2"
                  labelMarginLeft="14px"
                  inputColor="#21262F"
                  InputFontSize="14px"
                  InputFontWeight="400"
                  InputPadding="13px 65px 12px 14px"
                  colorBorder="solid 1px #8A92A2"
                />
              </div>

              <ButtonAddNew disabled={isButtonFarmDisabled} onClick={isButtonFarmDisabled ? null : onAddFarm} />
            </styles.InputAndButton>

            <div style={{ width: "100%", height: "50px" }}>
              <SelectV2Multi
                height="auto"
                marginBottom="24px"
                name="cultura"
                className="select"
                label="Cultura"
                labelWithAsterisk={false}
                id="cultura"
                value={culturaValue}
                disabled={false}
                loading={false}
                erro={cultureError}
                onChange={onCulturaChange}
                options={cultures}
                selectUniqueOption={true}
                buttonAddNew={false}
                messageErro={cultureError ? "Selecione uma cultura" : ""}
                isModal={true}
                isClearable={true}
                resetOnBlur={true}
                labelColor="#8A92A2"
                labelMarginLeft="14px"
                inputColor="#21262F"
                InputFontSize="14px"
                InputFontWeight="400"
                InputPadding="13px 65px 12px 14px"
                colorBorder="solid 1px #8A92A2"
              />
            </div>

            <InputV3
              id="datetime-start"
              type="datetime-local"
              label="Selecione Data e Hora de início"
              floatingLabelWithAsterisk="Data e Hora de início"
              value={startDateValue}
              onChange={onStartDateChange}
              hasError={startDateError}
            />

            <InputV3
              id="datetime-end"
              type="datetime-local"
              label="Selecione Data e Hora de término"
              floatingLabelWithAsterisk="Data e Hora de término"
              value={endDateValue}
              onChange={onEndDateChange}
              hasError={endDateError}
            />

            <InputV3
              ref={statusRef}
              type="select"
              floatingLabelWithAsterisk="Status"
              value={statusValue}
              onChange={onStatusChange}
              options={statusOptions}
              hasError={statusError}
              floatingValue={statusFloatingValue}
            />

            {hasMap ? (
              <div style={{ width: "100%", height: "270px", margin: "8px 0" }}>
                <p style={{ marginBottom: "8px" }}>Onde foi registrado o evento</p>
                <iframe
                  src={buildMapUrl(mapCoords.latitude, mapCoords.longitude)}
                  style={{ width: "100%", height: "100%", border: "0" }}
                  frameBorder="0"
                  scrolling="no"
                  allowTransparency
                  sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
                  title="Mapa meteorológico do evento"
                />
              </div>
            ) : null}

            {showComment ? (
              <CommentExample resourceType="calendar" resourceId={commentResourceId} />
            ) : null}

            <styles.ContainerSavedEvent>
              <styles.ButtonSaved onClick={onSave}>
                <TaglineM fontWeight={theme.typography.fontWeight.extraBold}>
                  {isLoading ? <styles.Loading /> : "Salvar evento"}
                </TaglineM>
              </styles.ButtonSaved>
            </styles.ContainerSavedEvent>
          </styles.WrapperNewCardRight>
        </styles.ContainerNewCardRight>
      </CardRightV2>
  );
};

export default ModalCreateOrEditEvent;
